<template>
  <div class="administration">
    <h1 class="administration__title page-title">
      Registration requests
    </h1>

    <div class="administration__content">
      <el-table
        :data="registrationRequestList"
        style="width: 100%"
        empty-text="No requests"
        class="administration__table"
      >
        <el-table-column prop="emailAddress" label="Email" :width="250">
          <template #default="scope">
            <div class="administration__table-email">
              {{ scope.row.emailAddress }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="Message">
          <template #default="scope">
            <div class="dash-if-empty administration__table-message">
              {{ scope.row.message ? scope.row.message : null }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Created on" :width="120">
          <template #default="scope">
            <div class="administration__table-created-on">
              {{ scope.row.createdOn }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="" :width="300">
          <template #default="scope">
            <div class="event-table__buttons">
              <el-button
                type="primary"
                @click="requestAcceptRegistrationRequest(scope.row.requestId)"
                :disabled="
                  isButtonDisabled(`handleRequest-${scope.row.requestId}`)
                "
              >
                Accept
              </el-button>
              <el-button
                type="primary"
                @click="requestRejectRegistrationRequest(scope.row.requestId)"
                :disabled="
                  isButtonDisabled(`handleRequest-${scope.row.requestId}`)
                "
              >
                Reject
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getRegistrationRequests,
  rejectRegistrationRequest,
  acceptRegistrationRequest,
} from '@/api/administration.js';
import { disableButton } from '@/mixins/disableButton.js';
import { showMessage } from '@/utils/messages.js';

export default {
  name: 'RegistrationRequestList',
  mixins: [disableButton],
  data() {
    return {
      registrationRequestList: [],
    };
  },
  mounted() {
    this.fetchRegistrationRequests();
  },
  computed: {},
  methods: {
    showMessage,
    async fetchRegistrationRequests() {
      const { data, success } = await getRegistrationRequests();

      if (success) {
        this.registrationRequestList = data.items;
      }
    },

    async requestRejectRegistrationRequest(requestId) {
      this.disableButton(`handleRequest-${requestId}`);

      const { success } = await rejectRegistrationRequest({ requestId });
      this.disableButton(`handleRequest-${requestId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Request has been rejected',
        });
        this.fetchRegistrationRequests();
      }
    },
    async requestAcceptRegistrationRequest(requestId) {
      this.disableButton(`handleRequest-${requestId}`);

      const { success } = await acceptRegistrationRequest({ requestId });
      this.disableButton(`handleRequest-${requestId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Request has been accepted',
        });
        this.fetchRegistrationRequests();
      }
    },
  },
};
</script>

<style lang="scss">
.administration {
  &__title {
    margin-top: 0;
  }

  &__content {
    padding-top: 0;
    overflow: hidden;
    padding: var(--global-dimension-size-125) var(--global-dimension-size-300)
      var(--global-dimension-size-400);
    background-color: var(--color-gray-50);
    border-radius: var(--border-radius-base);
  }
  &__table {
  }
  &__table-email {
  }
  &__table-created-on {
  }
}
</style>
